<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 23C11 24.6569 12.3431 26 14 26C15.6569 26 17 24.6569 17 23" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M6 18H22L20 15V10C20 6.68629 17.3137 4 14 4C10.6863 4 8 6.68629 8 10V15L6 18Z" stroke="white" stroke-width="1.8" stroke-linejoin="round" fill="none"/>
  <circle cx="21" cy="6" r="3.5" fill="#FF7B00" stroke="white" stroke-width="1"/>
</svg>
